import { TWITTER } from "@constants";

const generateFacebookShareLink = (text: string) => {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    text
  )}`;
};

const generateXTwitterShareLink = (text: string) => {
  const goWithGuideTwitter = TWITTER.replace("@", "");
  return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
    text
  )}&via=${goWithGuideTwitter}`;
};

const generateWhatsAppShareLink = (text: string) => {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
};

const generateEmailShareLink = ({
  subject,
  body,
}: {
  subject: string;
  body: string;
}) => {
  return `mailto:?subject=${subject}&body=${body}`;
};

const generateMessengerShareLink = () => {
  return "https://www.messenger.com";
};

export {
  generateFacebookShareLink,
  generateXTwitterShareLink,
  generateWhatsAppShareLink,
  generateEmailShareLink,
  generateMessengerShareLink,
};
